"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleSignInCallbackRequestForPagesRouter = void 0;
const constant_1 = require("../constant");
const utils_1 = require("../utils");
const handleSignInCallbackRequestForPagesRouter = async ({ request, response, handlerInput, userPoolClientId, oAuthConfig, setCookieOptions, origin, }) => {
    const { code, state, error, errorDescription } = (0, utils_1.parseSignInCallbackUrl)(request.url);
    if (errorDescription || error) {
        const searchParamsString = (0, utils_1.createErrorSearchParamsString)({
            error,
            errorDescription,
        });
        response.redirect(302, `${(0, utils_1.getRedirectOrDefault)(handlerInput.redirectOnSignOutComplete)}?${searchParamsString}`);
        return;
    }
    if (!code || !state) {
        response.status(400).end();
        return;
    }
    const { [constant_1.PKCE_COOKIE_NAME]: clientPkce, [constant_1.STATE_COOKIE_NAME]: clientState } = (0, utils_1.getCookieValuesFromNextApiRequest)(request, [
        constant_1.PKCE_COOKIE_NAME,
        constant_1.STATE_COOKIE_NAME,
    ]);
    // The state and pkce cookies are removed from cookie store after 5 minutes
    if (!clientState || !clientPkce) {
        const searchParamsString = (0, utils_1.createErrorSearchParamsString)({
            error: constant_1.SIGN_IN_TIMEOUT_ERROR_CODE,
            errorDescription: constant_1.SIGN_IN_TIMEOUT_ERROR_MESSAGE,
        });
        response.redirect(302, `${(0, utils_1.getRedirectOrDefault)(handlerInput.redirectOnSignOutComplete)}?${searchParamsString}`);
        return;
    }
    // Most likely the cookie has been tampered
    if (clientState !== state) {
        response.status(400).end();
        return;
    }
    const tokensPayload = await (0, utils_1.exchangeAuthNTokens)({
        redirectUri: (0, utils_1.resolveRedirectSignInUrl)(origin, oAuthConfig),
        userPoolClientId,
        oAuthConfig,
        code,
        codeVerifier: clientPkce,
    });
    if ('error' in tokensPayload) {
        response.status(500).send(tokensPayload.error);
        return;
    }
    (0, utils_1.appendSetCookieHeadersToNextApiResponse)(response, (0, utils_1.createTokenCookies)({
        tokensPayload,
        userPoolClientId,
    }), (0, utils_1.createTokenCookiesSetOptions)(setCookieOptions, origin));
    (0, utils_1.appendSetCookieHeadersToNextApiResponse)(response, (0, utils_1.createSignInFlowProofCookies)({ state: '', pkce: '' }), (0, utils_1.createAuthFlowProofCookiesRemoveOptions)(setCookieOptions));
    // When Cognito redirects back to `/sign-in-callback`, the referer is Cognito
    // endpoint. If redirect end user to `redirectOnSignInComplete` from this point,
    // the referer remains the same.
    // When authN token cookies set as `sameSite: 'strict'`, this may cause the
    // authN tokens cookies set with the redirect response not to be sent to the
    // server. Hence, sending a html page with status 200 to the client, and perform
    // the redirection on the client side.
    response
        .appendHeader('Content-Type', 'text/html')
        .status(200)
        .send((0, utils_1.createRedirectionIntermediary)({
        redirectTo: (0, utils_1.getRedirectOrDefault)(handlerInput.redirectOnSignInComplete),
    }));
};
exports.handleSignInCallbackRequestForPagesRouter = handleSignInCallbackRequestForPagesRouter;
